/*
 * @Author: yeyimei
 * @Date: 2022-11-21 15:29:47
 * @LastEditTime: 2023-06-16 10:25:47
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\store\modules\mc.js
 */
import { setSession, getSession } from "@/libs/storage"
const mc = {
  state: {
    mcCartList: getSession("MC_INFOS")?.cartList || [], //购物车数组
    mcNum: getSession("MC_INFOS")?.num || 0, //购物车数量
    mcTotalPrice: getSession("MC_INFOS")?.totalPrice || 0, //总价格
    mcVipDist: getSession("MC_INFOS")?.vipDist || 0, //会员优惠价
  },
  mutations: {
    setMcCartList(state, value) {
      state.mcCartList = value
      let mc_infos = getSession("MC_INFOS") || {}
      mc_infos.cartList = value
      setSession("MC_INFOS", mc_infos)
    },
    setMcNum(state, value) {
      state.mcNum = value
      let mc_infos = getSession("MC_INFOS") || {}
      mc_infos.num = value
      setSession("MC_INFOS", mc_infos)
    },
    setMcTotalPrice(state, value) {
      state.mcTotalPrice = value
      let mc_infos = getSession("MC_INFOS") || {}
      mc_infos.totalPrice = value
      setSession("MC_INFOS", mc_infos)
    },
    setMcVipDist(state, value) {
      state.mcVipDist = value
      let mc_infos = getSession("MC_INFOS") || {}
      mc_infos.vipDist = value
      setSession("MC_INFOS", mc_infos)
    },
  },
  actions: {},
  getters: {
    mcCartList: (state) => state.mcCartList,
  },
}
export default mc
